import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import DecorImage from '../assets/summer-girl-desktop.webp';
import { TENGE_LABEL } from '@/common/constants/common';
import { GESV_RATE, LOAN_AMOUNT_MAX_VALUE } from '@/common/constants/loan';
import { formatAmount } from '@/common/utils/formatNumber';
import { CalculatorWidget } from '@/components/CalculatorWidget';

const BannerDesktop = () => {
  return (
    <div className={styles.bannerSection}>
      <div className={styles.backgroundDecor} />
      <div className={cn('container', styles.container)}>
        <div className={styles.leftSide}>
          <h1 className={styles.title}>
            <FormattedMessage
              defaultMessage="Микрокредит онлайн на карту до {amount}"
              values={{
                amount: (
                  <span className={styles.actual}>
                    {formatAmount(LOAN_AMOUNT_MAX_VALUE)} {TENGE_LABEL}
                  </span>
                ),
              }}
            />
          </h1>
          <div className={styles.calculatorWrapper}>
            <CalculatorWidget className={styles.calculator} />
            <p className={styles.footnote}>
              *
              <FormattedMessage
                defaultMessage="ГЭСВ ставка в день от {gesvRate}, зависит от выбранной суммы микрокредита и сроков предоставления
                        займа"
                values={{ gesvRate: GESV_RATE }}
              />
            </p>
          </div>
        </div>
        <div className={styles.rightSide}>
          <img
            className={styles.decorImage}
            src={DecorImage}
            alt="decor image"
          />
          <div className={styles.bullet}>
            <span>
              <FormattedMessage defaultMessage="Всегда 0% первые 7 дней" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerDesktop;
